import api from "./api";

class EngineeringService {
    // ── ECNs ─────────────────────────────────────────────────────────────────

    listECNs(params = {}) {
        return api.get("/api/ecns/", { params });
    }

    nextECNNumber(year) {
        const params = year ? { year } : {};
        return api.get("/api/ecns/next-number/", { params });
    }

    getECN(id) {
        return api.get(`/api/ecns/${id}/`);
    }

    createECN(data) {
        return api.post("/api/ecns/", data);
    }

    updateECN(id, data) {
        return api.patch(`/api/ecns/${id}/`, data);
    }

    deleteECN(id) {
        return api.delete(`/api/ecns/${id}/`);
    }

    // ── Engineering Task Types ──────────────────────────────────────────────

    listTaskTypes() {
        return api.get("/api/engineering-task-types/");
    }

    // ── Engineering Schedule ────────────────────────────────────────────────

    listScheduleItems(params = {}) {
        return api.get("/api/engineering-schedule/", { params });
    }

    createScheduleItem(data) {
        return api.post("/api/engineering-schedule/", data);
    }

    updateScheduleItem(id, data) {
        return api.patch(`/api/engineering-schedule/${id}/`, data);
    }

    deleteScheduleItem(id) {
        return api.delete(`/api/engineering-schedule/${id}/`);
    }
}

export default new EngineeringService();
